// extracted by mini-css-extract-plugin
export default {"channelCell":"ContactConversationsPanel_channelCell__PLk0a"};